// extracted by mini-css-extract-plugin
export default {"subtitle":"UpdateFirmwareModal_subtitle__VtOtK","textButton":"UpdateFirmwareModal_textButton__3L-Zt"};